module.exports = __webpack_public_path__ + "img/vehiculogris.d9efa775.svg";